import React, { useState, useRef } from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import {
    Avatar,
    Card,
    CardContent,
    CardHeader,
    CardMedia,
    CardActions,
    Popper,
    Paper,
    MenuList,
    MenuItem,
    ClickAwayListener,
    Grow,
    Typography,
    makeStyles,
    IconButton,
    Divider,
    Chip,
    Button
} from '@material-ui/core'
import {
    FavoriteBorder,
    CommentOutlined,
    AssignmentLateOutlined,
    MoreHoriz,
    Send,
    CancelScheduleSend
} from '@material-ui/icons'
// import GetAppIcon from '@material-ui/icons/GetApp';
import moment from 'moment'
import Linkify from 'react-linkify'
import firebase from 'firebase/app'

const useStyles = makeStyles((theme) => ({
    link: {
        color: theme.palette.primary
    },
    root: {
        display: 'flex',
        flexDirection: 'column'
    },
    media: {
        height: 0,
        paddingTop: '56.25%', // 16:9
        '&:hover': {
            cursor: 'pointer'
        }
    },
    avatar: {}
}))

const PostCard = ({ className, post, list, setPosts, ...rest }) => {
    const classes = useStyles()
    const [open, setOpen] = useState(false)
    const anchorRef = useRef(null)

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen)
    }

    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return
        }

        setOpen(false)
    }

    function unpublishPost(id) {
        return firebase
            .firestore()
            .doc(`posts/${id}`)
            .update({ status: 'deleted' })
            .then(() => {
                const updatedPosts = list.map((post) => {
                    if (post.id === id) {
                        return {
                            ...post,
                            status: 'deleted'
                        }
                    } else return post
                })
                setPosts && setPosts(updatedPosts)
            })
    }

    function publishPost(id) {
        return firebase
            .firestore()
            .doc(`posts/${id}`)
            .update({ status: 'active' })
            .then(() => {
                const updatedPosts = list.map((post) => {
                    if (post.id === id) {
                        return {
                            ...post,
                            status: 'active'
                        }
                    } else return post
                })
                setPosts && setPosts(updatedPosts)
            })
    }

    const togglePostStatus = (post) => {
        if (
            window.confirm(
                `Do you really want to ${
                    post.status === 'active' ? 'unpublish' : 'publish'
                } the post?`
            )
        ) {
            post.status === 'active'
                ? unpublishPost(post.id)
                : publishPost(post.id)
        }
    }

    function handleListKeyDown(event) {
        if (event.key === 'Tab') {
            event.preventDefault()
            setOpen(false)
        }
    }

    // return focus to the button when we transitioned from !open -> open
    const prevOpen = React.useRef(open)
    React.useEffect(() => {
        if (prevOpen.current === true && open === false) {
            anchorRef.current.focus()
        }

        prevOpen.current = open
    }, [open])

    // if (isDeleted || !post) {
    //     return (
    //         <Card className={clsx(classes.root, className)} {...rest}>
    //             <CardContent style={{ paddingTop: !post.picture && 0 }}>
    //                 <Typography>
    //                     Uups! This item is deleted, or unavailable.
    //                 </Typography>
    //             </CardContent>
    //         </Card>
    //     )
    // }

    return (
        <Card className={clsx(classes.root, className)} {...rest}>
            <CardHeader
                avatar={
                    <Avatar aria-label="recipe" className={classes.avatar}>
                        <img
                            src={post.createdBy.photoURL}
                            alt={
                                post.createdBy.name +
                                '_' +
                                post.createdBy.surname
                            }
                            style={{ width: '100%', objectFit: 'cover' }}
                        />
                    </Avatar>
                }
                action={
                    <>
                        <IconButton
                            ref={anchorRef}
                            aria-controls={open ? 'menu-list-grow' : undefined}
                            aria-haspopup="true"
                            onClick={handleToggle}
                        >
                            <MoreHoriz />
                        </IconButton>
                        <Popper
                            open={open}
                            anchorEl={anchorRef.current}
                            role={undefined}
                            transition
                            disablePortal
                        >
                            {({ TransitionProps, placement }) => (
                                <Grow
                                    {...TransitionProps}
                                    style={{
                                        transformOrigin:
                                            placement === 'bottom'
                                                ? 'center top'
                                                : 'center bottom'
                                    }}
                                >
                                    <Paper>
                                        <ClickAwayListener
                                            onClickAway={handleClose}
                                        >
                                            <MenuList
                                                autoFocusItem={open}
                                                id="menu-list-grow"
                                                onKeyDown={handleListKeyDown}
                                            >
                                                {/* <MenuItem onClick={() => {}}>
                                                    <Visibility
                                                        style={{
                                                            marginRight: 10
                                                        }}
                                                    />
                                                    View Details
                                                </MenuItem> */}
                                                <MenuItem
                                                    onClick={() =>
                                                        togglePostStatus(post)
                                                    }
                                                >
                                                    {post.status ===
                                                    'active' ? (
                                                        <CancelScheduleSend
                                                            style={{
                                                                marginRight: 10
                                                            }}
                                                        />
                                                    ) : (
                                                        <Send
                                                            style={{
                                                                marginRight: 10
                                                            }}
                                                        />
                                                    )}
                                                    {post.status === 'active'
                                                        ? 'Unpublish'
                                                        : 'Publish'}
                                                </MenuItem>
                                                {/* <MenuItem onClick={deletePost}>
                                                    <Delete
                                                        style={{
                                                            marginRight: 10
                                                        }}
                                                    />
                                                    Delete
                                                </MenuItem> */}
                                            </MenuList>
                                        </ClickAwayListener>
                                    </Paper>
                                </Grow>
                            )}
                        </Popper>
                    </>
                }
                title={
                    post.byAdmin
                        ? post.createdBy.title
                        : post.createdBy.name + '  ' + post.createdBy.surname
                }
                subheader={moment(post.createDate.toDate()).format(
                    'HH:mm, DD.MM.YYYY'
                )}
            />
            {post.picture ? (
                <CardMedia
                    className={classes.media}
                    image={post.picture[0]}
                    title={post.text}
                />
            ) : null}
            {post.text ? (
                <CardContent style={{ paddingTop: !post.picture && 0 }}>
                    <Linkify
                        componentDecorator={(decoratedHref, decoratedText) => (
                            <a
                                key={decoratedHref}
                                className={classes.link}
                                href={decoratedHref}
                                target="_blank"
                                rel="noreferrer"
                            >
                                {decoratedText}
                            </a>
                        )}
                    >
                        <Typography variant="body2" component="span">
                            {post.text}
                        </Typography>
                    </Linkify>
                </CardContent>
            ) : null}

            {post.previewURL && !post.picture ? (
                <div style={{ backgroundColor: '#f2f2f2' }}>
                    <CardMedia
                        className={classes.media}
                        image={post.previewURL?.image}
                        title={post.text}
                        onClick={() =>
                            window.open(post.previewURL.URL, '_target')
                        }
                    />
                    <Button
                        onClick={() =>
                            window.open(post.previewURL.URL, '_target')
                        }
                    >
                        <CardContent
                            style={{ paddingTop: 10, paddingBottom: 10 }}
                        >
                            <Typography
                                variant="subtitle1"
                                color="textPrimary"
                                component="h4"
                                style={{
                                    textAlign: 'left',
                                    textTransform: 'none'
                                }}
                            >
                                {post.previewURL.title}
                            </Typography>
                            <Typography
                                variant="body2"
                                color="textSecondary"
                                component="p"
                                style={{
                                    textAlign: 'left',
                                    textTransform: 'none'
                                }}
                            >
                                {post.previewURL?.description}
                            </Typography>
                        </CardContent>
                    </Button>
                </div>
            ) : null}

            <Divider />
            <CardActions disableSpacing>
                <>
                    <IconButton aria-label="add to favorites">
                        <FavoriteBorder />
                    </IconButton>
                    <Typography
                        variant="body2"
                        color="textSecondary"
                        component="span"
                        style={{ marginLeft: 5, marginRight: 5 }}
                    >
                        {post.likeCount}
                    </Typography>
                </>
                <>
                    <IconButton aria-label="share">
                        <CommentOutlined />
                    </IconButton>
                    <Typography
                        variant="body2"
                        color="textSecondary"
                        component="span"
                        style={{ marginLeft: 5, marginRight: 5 }}
                    >
                        {post.commentCount}
                    </Typography>
                </>
                <>
                    <IconButton aria-label="show more">
                        <AssignmentLateOutlined />
                    </IconButton>
                    <Typography
                        variant="body2"
                        color="textSecondary"
                        component="span"
                        style={{ marginLeft: 5, marginRight: 5 }}
                    >
                        {post.reportCount ? post.reportCount : 0}
                    </Typography>
                </>
                <div style={{ marginLeft: 'auto' }}>
                    <Typography
                        variant="body2"
                        color="textSecondary"
                        component="span"
                        style={{ marginLeft: 5, marginRight: 5 }}
                    >
                        Status:{'  '}
                        <Chip
                            color={
                                post.status === 'active'
                                    ? 'primary'
                                    : post.status === 'deleted'
                                    ? 'warning'
                                    : 'default'
                            }
                            label={post.status}
                            size="small"
                        />
                    </Typography>
                </div>
            </CardActions>
        </Card>
    )
}

PostCard.propTypes = {
    className: PropTypes.string,
    post: PropTypes.object.isRequired,
    list: PropTypes.array,
    setPosts: PropTypes.func
}

export default PostCard
